import React from 'react';
import { motion } from 'framer-motion';
const careerSteps = [{
  dates: '2021–2024',
  title: 'Executive Chairman & GP',
  org: 'H2Transition Capital LLP, London',
  description: ''
}, {
  dates: '2017–Present',
  title: 'Chairman',
  org: 'Oblath Advisory, London',
  description: 'Global advisory to Boards and C-Suite on strategy, M&A, and the energy transition.'
}, {
  dates: '2013–2017',
  title: 'VP Downstream Global Portfolio Projects',
  org: 'Shell International, London',
  description: 'Led $2.6bn Australia divestment in under 9 months; co-led Shell Chemicals 2050 strategic review.'
}, {
  dates: '2009–2013',
  title: 'VP Downstream Portfolio Americas & Global Implementation',
  org: 'Shell, Houston',
  description: 'Led formation of $12bn+ Raizen JV with Cosan; managed $1bn+ liabilities.'
}, {
  dates: '1992–2009',
  title: 'Various Executive Roles',
  org: 'Shell (Houston, Singapore, London)',
  description: 'Progressive executive roles across global markets.'
}, {
  dates: '1978–1992',
  title: 'Various Leadership Roles',
  org: 'Goodyear Tire & Rubber',
  description: 'Including Board member & President, Toyobo Petcord (Toyobo/Goodyear JV), Osaka, Japan.'
}];
export function Career() {
  return <section id="career" className="py-24 bg-offwhite" data-id="element-52">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-54">
          <div className="mb-16 text-center" data-id="element-55">
            <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-56">
              Executive Career
            </h2>
            <div className="w-16 h-px bg-gold mx-auto" data-id="element-57"></div>
          </div>

          <div className="relative border-l border-gray-300 ml-4 md:ml-8" data-id="element-58">
            {careerSteps.map((step, index) => <div key={index} className="mb-12 ml-8 md:ml-12 relative group" data-id="element-59">
                <div className="absolute -left-[41px] md:-left-[57px] top-1 w-4 h-4 rounded-full bg-offwhite border-2 border-gold group-hover:bg-gold transition-colors duration-300" data-id="element-60"></div>

                <div className="flex flex-col md:flex-row md:items-baseline md:space-x-4 mb-2" data-id="element-61">
                  <span className="text-gold font-medium text-sm md:w-32 shrink-0" data-id="element-62">
                    {step.dates}
                  </span>
                  <h3 className="font-serif text-xl text-navy font-medium mt-1 md:mt-0" data-id="element-63">
                    {step.title}
                  </h3>
                </div>

                <div className="md:ml-36" data-id="element-64">
                  <h4 className="text-navy-light font-medium mb-2" data-id="element-65">
                    {step.org}
                  </h4>
                  {step.description && <p className="text-gray-600 text-sm leading-relaxed" data-id="element-66">
                      {step.description}
                    </p>}
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}